import { FC, MutableRefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { LayoutProps, layout } from 'styled-system';
import { RiErrorWarningLine } from 'react-icons/ri';
import { HStack, Text } from '@bpba/ui-components';

const ERROR_ICON_SIZE = 28;
const MAX_WIDTH = [270, 450];

type Props = {
  show?: boolean;
  errorMessage?: string;
};

export const ModalError: FC<Props> = ({ show, errorMessage }) => {
  const ref: MutableRefObject<HTMLParagraphElement | null> = useRef(null);

  /** Accesibilidad: se hace foco en el mensaje cuando se
   *  activa este componente de error.
   */
  useEffect(() => {
    if (show) ref?.current?.focus();
  }, [show]);

  if (!show) return <></>;
  return (
    <HStack backgroundColor={'secondary.2'} alignItems="center" padding={'16px'} borderRadius={4} marginTop="16px">
      <StyledErrorIcon width={ERROR_ICON_SIZE} height={ERROR_ICON_SIZE} />

      <StyledExternalText
        padding={'0px 0px 0px 8px !important'}
        fontSize={12}
        dangerouslySetInnerHTML={{ __html: errorMessage ?? '' }}
        maxWidth={MAX_WIDTH.map((value) => value - ERROR_ICON_SIZE)}
        tabIndex={0}
        ref={ref}
      />
    </HStack>
  );
};

const StyledExternalText = styled(Text)<LayoutProps>(layout, {
  a: {
    color: 'primary.0',
  },
});

const StyledErrorIcon = styled(RiErrorWarningLine)<LayoutProps>(layout, (props) => ({
  width: props.width,
  height: props.height,
}));
